import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, throwError } from 'rxjs';

import { ToastService } from '@shared/services/toast.service';
import { ToastTypes } from '@core/consts/toast';
import { ProblemDetails } from '@core/models/problem-details.model';
import { DEFAULT_PROBLEM_DETAILS } from '@core/consts/default-problem-details';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: unknown) => {
      let problemDetails: ProblemDetails = DEFAULT_PROBLEM_DETAILS;
      let status = DEFAULT_PROBLEM_DETAILS.status;

      if (error instanceof HttpErrorResponse) {
        status = error.status;

        if (isProblemDetails(error.error)) {
          problemDetails = { ...error.error, status };
        } else {
          problemDetails = { ...DEFAULT_PROBLEM_DETAILS, status };
        }
      }

      switch (status) {
        case 401:
          router.navigate(['/sign-in']);
          break;
        case 403:
          router.navigate(['/forbidden'], { replaceUrl: true });
          break;
        default:
          toastService.openToast(ToastTypes.SYSTEM_ERROR);
          break;
      }

      return throwError(() => problemDetails);
    }),
  );
};

function isProblemDetails(value: unknown): value is ProblemDetails {
  return (
    typeof value === 'object' &&
    value !== null &&
    'title' in value &&
    typeof value.title === 'string' &&
    'status' in value &&
    typeof value.status === 'number' &&
    'detail' in value &&
    typeof value.detail === 'string'
  );
}
